// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"d6b8b075","488":"c5e309fb","819":"021c06a9"}[chunkId] + ".chunk.js";
};